import { jsxs, jsx } from "react/jsx-runtime";
const IconChevronDownSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.25 6.083a.806.806 0 0 0-1.167 0L10 12.167 3.917 6.083a.806.806 0 0 0-1.167 0 .806.806 0 0 0 0 1.167l6.667 6.667a.9.9 0 0 0 .583.25.9.9 0 0 0 .583-.25L17.25 7.25a.806.806 0 0 0 0-1.167Z" })
    ]
  }
);
export {
  IconChevronDownSvg
};
